import React from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";
import {setEarliestPriceDates} from "../../../../utils";
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";
import {QuestionnairesHandlerResource} from "../../../../../../utils/api";


/**
 * Hook that handles all data initialization for the combined trade step.
 * - Builds transactions from portfolio data
 * - Validates instruments (extends with asset info)
 * - Fetches defaults
 * - Sets earliest price dates for virtual portfolios
 */
const useDataInitialization = ({
  portfolios,
  dataService,
  isVirtual,
  handlePortfolioSelect,
}) => {
  const dispatch = useDispatch();
  const [defaults, setDefaults] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      let currentPortfolios = portfolios;

      if (!isVirtual) {
        setDefaults(await QuestionnairesHandlerResource.getCombinedTradingDefaults(dataService.customer_id));
      } else {
        let instruments = [];

        currentPortfolios.map(portfolio => {
          for (let transactionType of [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SAVINGS_PLAN]) {
            if (!portfolio.transactions || _.isEmpty(portfolio.transactions[transactionType])) continue;
            instruments = instruments.concat(_.filter(portfolio.transactions[transactionType], i => !i.earliestPrice));
          }
        });

        if (!_.isEmpty(instruments)) {
          await setEarliestPriceDates(instruments, dispatch);
        }
      }

      handlePortfolioSelect(currentPortfolios.find(p => p.autoPortfolioBuilder) || currentPortfolios[0]);

      setLoading(false);
    })();
  }, []);

  return {defaults, setDefaults, loading};
};

export default useDataInitialization;
